import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DContext } from "../../../context/Datacontext";
import { IoReturnUpBackOutline } from "react-icons/io5";

export const ViewCourse = ({ openModal }) => {

    const { BeURL } = useContext(DContext);
    const { state } = useLocation();
    const navigate = useNavigate();

    const courseId = state?.courseId || null;

    const [course, setCourse] = useState(null);
    const [loading, setLoading] = useState(true);
    const [openSection, setOpenSection] = useState(null);
    const [openIndex, setOpenIndex] = useState(null);

    useEffect(() => {

        if (!courseId) return;

        const fetchCourse = async () => {

            try {

                const res = await fetch(`${BeURL}/view-course?courseId=${courseId}`, {
                    method: "GET",
                    credentials: "include"
                });

                const data = await res.json();

                if (data.success) {
                    setCourse(data.course);
                }

            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }

        };

        fetchCourse();

    }, [courseId, BeURL]);

    const handleTakeAction = (course) => {
        navigate("/app/course-pricing", {
            state: { course: course }
        });
    };

    if (loading) return <div className="p-10">Loading...</div>;
    if (!course) return <div className="p-10">No Course Found</div>;


    return (
        <div className="min-h-screen bg-gray-50 p-6 space-y-5 rounded-xl border shadow-xl">

            {/* BACK BUTTON */}
            <button
                onClick={() => navigate(-1)}
                className="flex items-center gap-2 text-primary-600 hover:text-primary-700 font-medium"
            >
                <IoReturnUpBackOutline size={20} /> Back
            </button>


            {/* HERO SECTION */}
            <div className="bg-white rounded-2xl shadow-sm border p-8 grid lg:grid-cols-3 gap-10">

                {/* LEFT CONTENT */}
                <div className="lg:col-span-2 space-y-5">

                    <h1 className="text-3xl font-bold text-gray-800">
                        {course.title}
                    </h1>

                    <p className="text-gray-600">
                        {course.shortDescription}
                    </p>

                    <div className="flex flex-wrap gap-6 text-sm text-gray-500">

                        <span>Level: <b>{course.level}</b></span>

                        <span>Language: <b>{course.language}</b></span>

                        <span>
                            Created: {new Date(course.createdAt).toDateString()}
                        </span>

                    </div>

                    {course.instructorDetails && (
                        <p className="text-sm">
                            Created by{" "}
                            <span className="text-primary-600 font-semibold">
                                {course.instructorDetails.fullName}
                            </span>
                        </p>
                    )}
                </div>


                {/* RIGHT PRICE CARD */}
                <div className="rounded-xl p-5 space-y-4">
                    <img
                        src={`${BeURL}${course?.thumbnail?.url}`}
                        alt="thumbnail"
                        className="w-full rounded-lg"
                    />

                    <div className="border-t pt-4 space-y-2">

                        <p className="text-sm text-gray-500">
                            Course Price
                        </p>

                        <div className="flex justify-between items-center">
                            <p className="text-2xl font-bold text-primary-600">
                                ₹{course.finalPrice}
                            </p>
                            <button onClick={() => handleTakeAction(course)} className="bg-primary-600 px-3 py-1 rounded-lg text-white font-semibold">Take Action</button>
                        </div>                    
                            {course.price !== course.finalPrice && (
                                <p className="text-sm line-through text-gray-400">
                                    ₹{course.price}
                                </p>
                            )}
                    </div>

                </div>

            </div>


            {/* BODY */}
            <div className="grid lg:grid-cols-3 gap-10">

                {/* LEFT CONTENT */}
                <div className="lg:col-span-2 space-y-8">


                    {/* DESCRIPTION */}
                    <div className="bg-white p-6 rounded-xl shadow-sm border">

                        <h2 className="text-xl font-semibold mb-3">
                            Course Description
                        </h2>

                        <p className="text-gray-700 whitespace-pre-line">
                            {course.description}
                        </p>

                    </div>


                    {/* SKILLS */}
                    <div className="bg-white p-6 rounded-xl shadow-sm border">

                        <h2 className="text-xl font-semibold mb-3">
                            Skills You Will Learn
                        </h2>

                        <div className="flex flex-wrap gap-3">

                            {course.skills?.map((skill, i) => (

                                <span
                                    key={i}
                                    className="px-3 py-1 bg-primary-50 text-primary-600 rounded-full text-sm"
                                >
                                    {skill}
                                </span>

                            ))}

                        </div>

                    </div>


                    {/* COURSE CONTENT */}
                    <div className="bg-white p-6 rounded-xl shadow-sm border">

                        <h2 className="text-xl font-semibold mb-4">
                            Course Content
                        </h2>

                        {course.syllabuses?.map((syllabus, index) => {

                            const isOpen = openSection === index;

                            return (

                                <div key={index} className="border-b last:border-none">

                                    <div
                                        onClick={() => setOpenSection(isOpen ? null : index)}
                                        className="cursor-pointer py-4 flex justify-between items-center"
                                    >

                                        <div>

                                            <h3 className="font-medium">
                                                {syllabus.name}
                                            </h3>

                                            <p className="text-sm text-gray-500">
                                                {syllabus.assets?.length || 0} lectures
                                            </p>

                                        </div>

                                        <span className="text-xl">
                                            {isOpen ? "-" : "+"}
                                        </span>

                                    </div>


                                    {isOpen && (

                                        <div className="pb-4 space-y-3">

                                            {syllabus.assets?.map((asset, i) => (

                                                <div
                                                    key={asset._id}
                                                    className="flex justify-between items-center bg-gray-50 p-3 rounded-lg"
                                                >

                                                    <div>

                                                        <p className="text-sm font-medium">
                                                            {i + 1}. {asset.title}
                                                        </p>

                                                        <p className="text-xs text-gray-500">
                                                            {asset.description}
                                                        </p>

                                                    </div>

                                                    {asset.file?.url && (

                                                        <a
                                                            href={`${BeURL}${asset.file.url}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-primary-600 text-sm hover:underline"
                                                        >
                                                            View
                                                        </a>

                                                    )}

                                                </div>

                                            ))}

                                        </div>

                                    )}

                                </div>

                            );

                        })}

                    </div>

                    <div className="bg-white p-6 rounded-xl shadow-sm border">
                        <h2 className="text-xl font-semibold mb-4">FAQ</h2>

                        {course.faq?.map((faq, index) => {
                            const isOpen = openIndex === index;

                            return (
                                <div key={index} className="border-b last:border-none">

                                    {/* Question */}
                                    <div
                                        onClick={() => setOpenIndex(isOpen ? null : index)}
                                        className="cursor-pointer py-4 flex justify-between items-center"
                                    >
                                        <h3 className="font-medium">
                                            {faq.question}
                                        </h3>

                                        <span className="text-xl">
                                            {isOpen ? "-" : "+"}
                                        </span>
                                    </div>

                                    {/* Answer */}
                                    {isOpen && (
                                        <div className="pb-4 text-sm text-gray-600">
                                            {faq.answer}
                                        </div>
                                    )}

                                </div>
                            );
                        })}
                    </div>

                </div>


                {/* RIGHT SIDEBAR */}
                <div className="space-y-6">

                    <div className="bg-white p-6 rounded-xl shadow-sm border">

                        <h3 className="font-semibold mb-3">
                            Course Details
                        </h3>

                        <div className="space-y-2 text-sm text-gray-600">

                            <p>
                                <b>Level:</b> {course.level}
                            </p>

                            <p>
                                <b>Language:</b> {course.language}
                            </p>

                            <p>
                                <b>Total Sections:</b> {course.syllabuses?.length}
                            </p>

                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
};